<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-input size="small" @keyup.enter.native="handleFilter" style="width: 70%; margin-right: 10px"
            class="filter-item" placeholder="案件编号，邮件主题，接收人" v-model="listQuery.name">
          </el-input>
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">搜索</el-button>
          <el-button v-if="status == 'asc'" size="small" class="filter-item" type="primary"
            @click="sortEmail">升序</el-button>
          <el-button v-if="status == 'desc'" size="small" class="filter-item" type="primary"
            @click="sortEmail">降序</el-button>

          <el-button size="small" class="filter-item" v-permission:function="['czMessageManager_btn_add']"
            style="margin-left: 10px" @click="handleCreate" type="primary" icon="edit">添加</el-button>
        </div>
      </div>
    </template>

    <el-table :key="tableKey" :data="list" v-loading.body="listLoading" size="small" stripe border type="index"
      highlight-current-row style="width: 100%">
      <el-table-column align="center" label="id" width="65">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="150px" align="center" label="案件id">
        <template slot-scope="scope">
          <span>{{ scope.row.caseId }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="邮件主题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column width="400px" align="center" label="消息内容">
        <template slot-scope="scope">
          <el-link type="primary" v-if="contentList[scope.$index].content != ''"
            @click="showContent(scope.row.content)">
            {{ contentList[scope.$index].content }}
          </el-link>

          <div v-else v-html="scope.row.content"></div>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == '1'">系统弹窗消息</span>
          <span v-else-if="scope.row.type == '2'">短信消息</span>
          <span v-else>邮件消息</span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="150px" align="center" label="发送的手机号码">
      <template slot-scope="scope">
        <span>{{scope.row.phone}}</span>
      </template>
    </el-table-column> -->
      <el-table-column width="150px" align="center" label="发送的邮箱">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100px" align="center" label="发送是否成功">
        <template slot-scope="scope">
          <span v-if="scope.row.sendStatus === 0" style="color: skyblue">未发送</span>
          <span v-if="scope.row.sendStatus === -1" style="color: red">发送失败</span>
          <span v-if="scope.row.sendStatus === 1" style="color: green">发送成功</span>
          <span v-if="scope.row.sendStatus === 2" style="color: rgb(15, 255, 191)">重发成功</span>
          <span v-if="scope.row.sendStatus === -2" style="color: rgb(215, 58, 14)">重发失败</span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="150px" align="center" label="消息创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column> -->
      <el-table-column width="150px" align="center" label="发送时间">
        <template slot-scope="scope">
          <span>{{ scope.row.sendTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-dropdown @command="handleCommand">
            <el-button type="primary">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-permission:function="['czMessageManager_btn_reSend']"
                :command="switchButton(scope.row, 'reSend')">重发</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czMessageManager_btn_edit']"
                :command="switchButton(scope.row, 'edit')">编辑</el-dropdown-item>

              <el-dropdown-item v-permission:function="['czMessageManager_btn_cancel']"
                :command="switchButton(scope.row, 'cancel')">取消提醒</el-dropdown-item>
              <el-dropdown-item v-permission:function="['czMessageManager_btn_del']"
                :command="switchButton(scope.row, 'del')">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <!-- <el-button
            v-permission:function="['czMessageManager_btn_reSend']"
            size="small"
            type="success"
            @click="handleReSend(scope.row.id)"
            >
          </el-button>
          <el-button
            v-permission:function="['czMessageManager_btn_edit']"
            size="small"
            type="success"
            @click="handleUpdate(scope.row)"
            >编辑
          </el-button>
          <el-button
            v-permission:function="['czMessageManager_btn_del']"
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除
          </el-button> -->
      </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="案件id" prop="caseId">
          <el-input v-model="form.caseId" placeholder="请输入案件id"></el-input>
        </el-form-item>
        <el-form-item label="邮件主题" prop="title">
          <el-input v-model="form.title" placeholder="请输入邮件主题"></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input v-model="form.content" placeholder="请输入消息内容"></el-input>
        </el-form-item>
        <el-form-item label="类型(1：系统弹窗消息  2:短信消息 3：邮件消息)" prop="type">
          <el-input v-model="form.type" placeholder="请输入类型(1：系统弹窗消息  2:短信消息 3：邮件消息)"></el-input>
        </el-form-item>
        <el-form-item label="发送的手机号码" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入发送的手机号码"></el-input>
        </el-form-item>
        <el-form-item label="发送的邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入发送的邮箱"></el-input>
        </el-form-item>
        <el-form-item label="发送是否成功" prop="sendStatus">
          <el-input v-model="form.sendStatus" placeholder="请输入发送是否成功"></el-input>
        </el-form-item>
        <el-form-item label="消息创建时间" prop="createTime">
          <el-input v-model="form.createTime" placeholder="请输入消息创建时间"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')" size="small">取 消</el-button>
        <el-button v-if="dialogStatus == 'create'" size="small" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="邮件详情" :showClose="false" :visible.sync="contentVisible" width="70%" center>
      <div>
        <div :style="{ height: contentHeight }" v-html="content"></div>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  page,
  addObj,
  getObj,
  delObj,
  putObj,
  handleReSend,
  sortEmail,
  cancelSend,
} from "@/api/czManager/czMessage/index";
import { mapGetters } from "vuex";
export default {
  name: "czMessage",
  data() {
    return {
      status: "desc",
      contentList: [],
      contentVisible: false,
      content: "",
      form: {
        caseId: undefined,
        title: undefined,
        content: undefined,
        type: undefined,
        phone: undefined,
        email: undefined,
        sendStatus: undefined,
        createTime: undefined,
      },
      rules: {
        caseId: [
          {
            required: true,
            message: "请输入案件id",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入邮件主题",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入消息内容",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入类型(1：系统弹窗消息  2:短信消息 3：邮件消息)",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入发送的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入发送的邮箱",
            trigger: "blur",
          },
        ],
        sendStatus: [
          {
            required: true,
            message: "请输入发送是否成功",
            trigger: "blur",
          },
        ],
        createTime: [
          {
            required: true,
            message: "请输入消息创建时间",
            trigger: "blur",
          },
        ],
      },
      contentHeight: '',
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "创建",
      },
      tableKey: 0,
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters(["elements"]),
  },
  methods: {
    showContent(content) {
      this.contentHeight = (content.split('/tr').length * 50) + 'px'
      this.contentVisible = true;
      this.content = content;
    },
    sortEmail() {
      if (this.status == "asc") {
        this.status = "desc";
      } else {
        this.status = "asc";
      }
      this.listLoading = true;
      this.getList()
    },
    handleCommand(command) {
      if (command.row == "edit") {
        this.handleUpdate(command.index);
        return;
      }
      if (command.row == "del") {
        this.handleDelete(command.index);
        return;
      }
      if (command.row == "reSend") {
        this.handleReSend(command.index.id);
        return;
      }
      if (command.row == "cancel") {
        this.$confirm("是否确定取消发送, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            cancelSend(command.index.id).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "success",
                });
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      }
    },
    switchButton(index, row, command) {
      return {
        index: index,
        row: row,
        command: command,
      };
    },
    getList() {
      this.listLoading = true;
      sortEmail(this.status, this.listQuery).then((response) => {
        this.list = response.rows;
        this.contentList = [];
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].content.indexOf("html") != -1) {
            this.contentList.push({
              id: this.list[i].id,
              content: "查看更多",
            });
            // this.list[i].content = ''
          } else {
            this.contentList.push({
              id: this.list[i].id,
              content: "",
            });
          }
        }
        this.total = response.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleReSend(id) {
      handleReSend(id).then((response) => {
        if (response.statusCode == 2000) {
          this.$message({
            duration: 5000,
            message: response.message,
            type: "success",
          });
        } else {
          this.$message({
            duration: 5000,
            message: response.message,
            type: "error",
          });
        }
        this.getList();
      });
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
    },
    handleUpdate(row) {
      getObj(row.id).then((response) => {
        this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = "update";
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delObj(row.id).then(() => {
          this.$notify({
            title: "成功",
            message: "删除成功",
            type: "success",
            duration: 2000,
          });
          this.getList();
        });
      });
    },
    create(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          addObj(this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },
    update(formName) {
      const set = this.$refs;
      set[formName].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          this.form.password = undefined;
          putObj(this.form.id, this.form).then(() => {
            this.dialogFormVisible = false;
            this.getList();
            this.$notify({
              title: "成功",
              message: "创建成功",
              type: "success",
              duration: 2000,
            });
          });
        } else {
          return false;
        }
      });
    },
    resetTemp() {
      this.form = {
        username: undefined,
        name: undefined,
        sex: "男",
        password: undefined,
        description: undefined,
      };
    },
  },
};
</script>
<style>
.el-dialog__body {
  padding: 0 0 !important
}
</style>